import { createSuitMixin as t } from "../mixins/suit.js";
import { _objectSpread as e } from "../util/polyfills.js";
import "../util/vue-compat/index-vue2.js";
import { createWidgetMixin as r } from "../mixins/widget.js";
var n;
export default ((n = {
  name: "AisStateResults",
  mixins: [r({
    connector: !0
  }), t({
    name: "StateResults"
  })],
  props: {
    catchError: {
      type: Boolean,
      default: !1
    }
  },
  data: function data() {
    var t = this;
    return {
      renderFn: function renderFn() {
        var e = t.instantSearchInstance,
            r = e.status,
            n = e.error,
            s = t.getParentIndex().getResults(),
            i = t.getParentIndex().getHelper(),
            a = i ? i.state : null;
        t.state = {
          results: s,
          state: a,
          status: r,
          error: n
        };
      }
    };
  },
  created: function created() {
    this.instantSearchInstance.addListener("render", this.renderFn), this.renderFn();
  }
}).beforeDestroy = function () {
  this.widget && (this.instantSearchInstance.removeListener("render", this.renderFn), this.errorFn && this.instantSearchInstance.removeListener("error", this.errorFn));
}, n.watch = {
  catchError: {
    immediate: !0,
    handler: function handler(t) {
      t ? (this.errorFn = function () {}, this.instantSearchInstance.addListener("error", this.errorFn)) : this.errorFn && (this.instantSearchInstance.removeListener("error", this.errorFn), this.errorFn = void 0);
    }
  }
}, n.computed = {
  stateResults: function stateResults() {
    var t = this.state,
        r = t.results,
        n = t.state,
        s = t.status,
        i = t.error;
    return e({}, r, {
      results: r,
      state: n,
      status: s,
      error: i
    });
  }
}, n);